<mat-progress-bar color="primary" [mode]="loading ? 'buffer' : 'determinate'"></mat-progress-bar>
<div class="content">
    <router-outlet></router-outlet>
</div>
